<footer>

  <div class=”d-none” itemscope="" itemtype="http://schema.org/Organization">
    <meta content="EVLAND" itemprop="name">
    <meta content="+380668898990" itemprop="telephone">
    <meta content="info@ev.land" itemprop="email">
    <meta content="вулиця Газопровідна, 43, Київ, Украина" i18n-content itemprop="address">
    <meta content="https://ev.land/assets/images/logo-simple.svg" itemprop="logo">
    <meta content="EVLAND" itemprop="legalName">
    <link content="https://ev.land" href="https://ev.land" itemprop="url">
  </div>

  <div class="container">

    <div class="top-bar">

      <div class="row justify-content-sm-between align-items-center">

        <div class="col-12 col-md-auto mb-3 mb-lg-0">

          <a class="logo d-inline-block" routerLink="/">
            <img alt="Логотип EVLAND" height="38" i18n-alt ngSrc="/assets/images/logo-with-label.svg" width="141" />
          </a>

        </div>

        <div class="col-12 col-md-auto">

          <div class="hint" i18n><sup>*</sup> Ціни на сайті орієнтовні та не є публічною офертою, для отримання точної
            ціни зверніться до менеджерів.
          </div>

        </div>

      </div>

    </div>

    <div class="content">

      <div class="row">

        @for (group of contentLinkGroups(); track group.label; let isFirst = $first) {

          <div class="col-12 col-md-6 col-xl-3">

            @if (!isFirst) {
              <div class="delimiter d-md-none"></div>
            }

            <div class="title">{{ group.label }}</div>

            <ul class="content-menu-list list-unstyled" itemscope itemtype="http://schema.org/SiteNavigationElement">

              @for (link of group.links; track link.label) {

                <li class="content-menu-list-item">

                  @if (link.href) {
                    <a [class.disabled]="link.disabled" [routerLink]="link.href"
                       [routerLinkActiveOptions]="{exact: link.href === '/'}" routerLinkActive="active"
                       class="content-menu-link d-inline-flex flex-row justify-content-start align-items-center" itemprop="url">
                      <span>{{ link.label }}</span>
                      @if (link.badge) {
                        <div class="ms-2 badge bg-primary">{{link.badge}}</div>
                      }
                      <meta [content]="link.label" itemprop="name">
                    </a>
                  } @else {
                    <div (click)="onActionClick(link.action)" [class.disabled]="link.disabled"
                         class="content-menu-link">
                      {{ link.label }}
                    </div>
                  }

                </li>

              }

            </ul>

          </div>

        }

        <div class="col-md-6 col-xl-3">

          <div class="delimiter d-xl-none"></div>

          <div class="title" i18n>Контакти</div>

          <div class="subtitle my-2">Київ</div>

          <div class="mb-2">
            <a class="phone-link d-inline-flex flex-row justify-content-start align-items-center"
               href="tel:+380668898990">
              <mat-icon class="icon me-2" svgIcon="custom:vodafone"></mat-icon>
              <span class="label">+380 (66) 889 89 90</span>
            </a>
          </div>

          <div class="mb-2">
            <a class="phone-link d-inline-flex flex-row justify-content-start align-items-center"
               href="tel:+380688898998">
              <mat-icon class="icon me-2" svgIcon="custom:kyivstar"></mat-icon>
              <span class="label">+380 (68) 889 89 98</span>
            </a>
          </div>

          <div class="mb-2">
            <a class="phone-link d-inline-flex flex-row justify-content-start align-items-center"
               href="tel:+380938898998">
              <mat-icon class="icon me-2" svgIcon="custom:lifecell"></mat-icon>
              <span class="label">+380 (93) 889 89 98</span>
            </a>
          </div>

          <div class="subtitle my-2">Вінниця</div>

          <div class="mb-2">
            <a class="phone-link d-inline-flex flex-row justify-content-start align-items-center"
               href="tel:tel:+380671010021">
              <mat-icon class="icon me-2" svgIcon="custom:kyivstar"></mat-icon>
              <span class="label">+380 (67) 101 00 21</span>
            </a>
          </div>

        </div>

        <div class="col-md-6 col-xl-3">

          <div class="delimiter d-xl-none"></div>

          <div class="title">Адреса та графік</div>

          <ul class="contacts-list list-unstyled">

            <li class="contacts-list-item d-flex flex-row align-items-center">
              <mat-icon class="icon" svgIcon="sax:bulk-location"></mat-icon>
              <a class="label" href="https://maps.app.goo.gl/Jvd9pFdi1g9MzeDU9" i18n target="_blank">вулиця Газопровідна, 43, Київ, Україна</a>
            </li>

            <li class="contacts-list-item d-flex flex-row align-items-center">
              <mat-icon class="icon" svgIcon="sax:bulk-location"></mat-icon>
              <a class="label" href="https://maps.app.goo.gl/vJY4Li7PJ4FTcexZ6" i18n target="_blank">вулиця 600-річчя, 21, Вінниця, Україна</a>
            </li>

            <li class="contacts-list-item d-flex flex-row align-items-center">
              <mat-icon class="icon" svgIcon="sax:bulk-clock-1"></mat-icon>
              <div class="label d-inline-flex" i18n>Пн-Пт: 10:00-18:30 <br />Сб: 10:00-17:00 <br />Нд: Вихідний</div>
            </li>

            <li class="contacts-list-item d-flex flex-row align-items-center">
              <mat-icon class="icon" svgIcon="sax:bulk-sms"></mat-icon>
              <a class="label" href="mailto:info@ev.land">{{ 'info@ev.land' }}</a>
            </li>

          </ul>

        </div>

      </div>

    </div>

    <div class="chats-and-manager">

      <div class="row">

        <div class="col-md-6 col-xl-4 mb-4 mb-xl-0">

          <div class="title mb-3" i18n>Підпишіться на Telegram</div>

          <p class="description mb-3" i18n>Обмінюйтеся думками, порадами та досвідом з іншими ентузіастами. Створіть з
            нами
            майбутнє чистої мобільності!</p>

          <a class="btn btn-telegram d-inline-flex flex-row justify-content-center align-items-center"
             href="https://t.me/chademoforchina"
             target="_blank">
            <mat-icon class="icon me-2" svgIcon="social:telegram-inverted"></mat-icon>
            <span i18n>Підписатися</span>
          </a>
        </div>

        <div class="col-md-6 col-xl-4 mb-4 mb-xl-0">

          <div class="title mb-3" i18n>Підпишіться на Viber</div>

          <p class="description mb-3" i18n>Дізнається про надходження нових моделей автівок та вигідних пропозицій від
            наших
            партнерів першим.</p>

          <a class="btn btn-viber d-inline-flex flex-row justify-content-center align-items-center"
             href="https://invite.viber.com/?g2=AQAxXbbRQOHyE1Jnn5nskiaUR91VtNzgMBbLcOHkK7QC4ckyMo5NiPq7faLI%2Fq1r"
             target="_blank">
            <mat-icon class="icon me-2" svgIcon="social:viber"></mat-icon>
            <span i18n>Підписатися</span>
          </a>

        </div>

        <div class="col-xl-4">

          <div class="title mb-3" i18n>Ми готові допомогти</div>

          <p class="description mb-3" i18n>Маєте запитання щодо вибору авто чи фінансування? Наші експерти допоможуть
            знайти
            найкраще рішення!</p>

          <button (click)="openCallbackModal()" class="btn btn-consult btn-primary" i18n>Консультація</button>

        </div>

      </div>

    </div>

    <div class="bottom-bar">

      <div class="row flex-row justify-content-between align-items-center">

        <div class="col-12 col-md-auto">

          <ul class="important-links-list list-inline" itemscope itemtype="http://schema.org/SiteNavigationElement">

            @for (navLink of importantNavLinks; track navLink.label) {

              <li class="list-inline-item d-flex d-md-inline-flex">

                <a [routerLink]="navLink.href" [fragment]="navLink.fragment" class="important-link" itemprop="url">
                  {{ navLink.label }}
                </a>

              </li>

            }

          </ul>

        </div>

        <div class="col-12 col-md-auto">
          <div class="social-block d-inline-flex flex-row align-items-center">

            <div class="label d-none d-sm-inline-flex" i18n>Наші соціальні мережі</div>

            <ul class="social-links-list list-inline">

              @for (navLink of socialNavLinks; track navLink.label) {

                <li class="list-inline-item">

                  <a [href]="navLink.href" [title]="navLink.label" target="_blank" class="social-link d-inline-block">
                    <mat-icon [svgIcon]="navLink.icon" class="icon"></mat-icon>
                  </a>

                </li>

              }

            </ul>

          </div>

        </div>

      </div>

    </div>

  </div>

</footer>
